

















































































































import { computed, defineComponent, getCurrentInstance, reactive, ref, watch } from '@vue/composition-api';
import { StepItemProps, SubmitContext } from 'tdesign-vue';

import i18n, { i18n_t } from '@/locales/i18n';
import { formHandler } from '@/renderer/views/desktop/ManageConsole/UIDesign/composition/formHandler';
import tips, { MsgError } from '@/renderer/scripts/utils/tips';
import orgNameValidator from '@/renderer/views/desktop/ManageConsole/UIDesign/orgNameValidator';
import ConstantConfig from '@/renderer/scripts/utils/ConstantConfig';
import smh from '@/renderer/scripts/smh';
import store from '@/renderer/store';

export default defineComponent({
  name: 'StepForm1',
  setup(props, context) {
    const vm = getCurrentInstance()?.proxy || context.root;
    const { $store } = vm;
    const defaultOrgName = computed(() => $store.getters.orgName);
    const defaultShowOrgName = computed(() => $store.getters.showOrgName);
    const defaultOrgLogo = computed(() => $store.getters.orgLogo);
    // 默认的formData数据
    const formData = reactive({
      orgName: defaultOrgName.value,
      showOrgName: defaultShowOrgName.value,
    });
    const {
      logoInfo,
      files,
      orgLogo,
      uploadComp,
      uploading,
      fileSizeError,
      fileTypeError,
      selectedFile,
      resPath,
      isUsingDefaultLogo,
      methods: { beforeUpload, cancelUpload },
    } = formHandler().logoUploadHandler({
      // 考虑到有部分逻辑是需要自行处理的，且这里的逻辑只会执行一次,故直接内嵌函数
      afterUploadCOS: (
        tempLogoSrc: string,
        {
          name,
          size,
        }: {
          name: string;
          size: number;
        },
      ) => {
        tips.success(i18n_t('图片上传成功'));
      },
    });
    const orgNameValidate = computed(
      () => formData.orgName === '' || formData.orgName.length > ConstantConfig.orgNameMaxLength,
    );
    const submitBtnDisabled = computed(
      () =>
        (formData.orgName === defaultOrgName.value &&
          orgLogo.value === defaultOrgLogo.value &&
          formData.showOrgName === defaultShowOrgName.value) ||
        uploading.value ||
        orgNameValidate.value,
    );
    const { rules } = orgNameValidator(formData.orgName);
    const methods = {
      sub() {
        const form = vm.$refs.form as any;
        form.submit();
      },
      useDefaultLogo(e: Event) {
        const { defaultLogo } = store.getters;
        e.stopPropagation();
        e.preventDefault();
        orgLogo.value = defaultLogo;
        selectedFile.value = false;
      },
      async submit({ validateResult, firstError }: SubmitContext<FormData>) {
        if (validateResult !== true) {
          tips.warning(firstError as string);
          return;
        }
        await this.confirm();
      },
      async confirm() {
        // 企业名称 输入
        if (formData.orgName !== defaultOrgName.value) {
          try {
            await smh.userAPI.updateOrgInfo({
              name: formData.orgName,
            });
            store.commit('SET_ORG_NAME', formData.orgName);
            tips.success(i18n_t('修改成功'));
            reporter.report('manager_new_guide_success', {
              success_count_type: 'step_one_name',
            });
          } catch (e) {
            tips.error(e as MsgError);
          }
        }
        // 展示名称 开关
        if (formData.showOrgName !== defaultShowOrgName.value) {
          try {
            await smh.userAPI.updateOrgInfo({
              extensionData: {
                showOrgNameInUI: formData.showOrgName,
              },
            });
            store.commit('SET_SHOW_ORG_NAME', formData.showOrgName);
            tips.success(i18n_t('修改成功'));
            reporter.report('manager_new_guide_success', {
              success_count_type: 'step_one_show_org_name',
            });
          } catch (e) {
            tips.error(e as MsgError);
          }
        }
        // logo图片
        if (orgLogo.value !== defaultOrgLogo.value) {
          const { defaultLogo } = store.getters;
          try {
            let saveOrgLogo = '';
            if (isUsingDefaultLogo.value) {
              await smh.userAPI.postOrgLogo({
                filePath: '',
              });
              saveOrgLogo = defaultLogo;
            } else {
              const res = await smh.userAPI.postOrgLogo({
                filePath: resPath.value,
              });
              saveOrgLogo = `${$store.getters.protocol}:${res.data.logo}`;
            }
            orgLogo.value = saveOrgLogo;
            store.commit('SET_ORG_LOGO', saveOrgLogo);
            tips.success(i18n_t('修改成功'));
            selectedFile.value = false;
            reporter.report('manager_new_guide_success', {
              success_count_type: 'step_one_name_logo',
            });
          } catch (e) {
            tips.error(e as MsgError);
            orgLogo.value = defaultLogo;
            selectedFile.value = false;
          }
        }
      },
      /**
       * 更新最新的stepNumber
       * @param number
       */
      updateStepNumber(number: number) {
        context.emit('update:stepNumber', number);
      },
    };
    const hasLogo = ref(false);
    if (defaultOrgLogo.value) {
      hasLogo.value = true;
      const newImg = new Image();
      newImg.src = defaultOrgLogo.value;
      newImg.onload = () => {
        orgLogo.value = newImg.src;
      };
    }
    return {
      ConstantConfig,
      rules,
      formData,
      files,
      logoInfo,
      uploadComp,
      uploading,
      fileSizeError,
      fileTypeError,
      selectedFile,
      resPath,
      beforeUpload,
      cancelUpload,
      isUsingDefaultLogo,
      hasLogo,
      orgLogo,
      submitBtnDisabled,
      ...methods,
    };
  },
});
